// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
const Demo = () => (
  <section id="demo" style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px 40px", display: "flex", flexDirection: "column", gap: "40px", position: "relative" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: "24px", flexWrap: "wrap" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxWidth: "680px" }}>
        <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
          جولة داخل التطبيق
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2", width: "min(812px, calc(100vw - 48px))" }}>
          <blockquote dir="rtl">
            <p dir="rtl">
              <strong>
                عالم كامل وآمن… بين يدي طفلك
                <br />
              </strong>
            </p>
          </blockquote>
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
          <img width="560" height="560" loading="lazy" decoding="async" src="/assets/img/boy-head.webp" alt="" style={{ width: "64px", height: "64px", borderRadius: "50%", objectFit: "cover", objectPosition: "50% 20%", background: "#141C63", border: "3px solid #46D3BE", boxShadow: "0 0 0 5px rgba(70,211,190,0.18)" }} />
          <p style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(24px, 2.6vw, 32px)", lineHeight: "1.3", color: "#141C63" }}>
            {"لعبة جادّة يعيشها الطفل "}
            <span style={{ display: "inline-block", padding: "0 14px", borderRadius: "14px", background: "#FFC93C", color: "#0B1240", boxShadow: "0 4px 0 #C48E00" }}>
              كبطل
            </span>
          </p>
        </div>
      </div>
      <a href="https://khotoua.com/KHOTOUA_DEMO/Khotoua%20Inscription%20Portrait.dc.html" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "56px", padding: "0 26px", borderRadius: "18px", background: "#141C63", color: "#FFFFFF", fontWeight: "800", fontSize: "17px", textDecoration: "none" }}>
        جرّب العرض التجريبي
      </a>
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(380px, 100%), 1fr))", gap: "20px", alignItems: "stretch" }}>
      <figure style={{ margin: "0", gridRow: "span 2", background: "#141C63", borderRadius: "32px", padding: "28px 24px", display: "flex", flexDirection: "column", alignItems: "center", gap: "18px", color: "#FFFFFF" }}>
        <div style={{ width: "280px", maxWidth: "100%", borderRadius: "40px", border: "8px solid #0B1240", overflow: "hidden", boxShadow: "0 30px 60px rgba(0,0,0,0.4)" }}>
          <img width="800" height="1734" loading="lazy" decoding="async" src="/assets/img/screen-welcome.webp" alt="شاشة الترحيب في تطبيق خطوة: مرحبا بك" style={{ width: "100%", display: "block" }} />
        </div>
        <figcaption style={{ display: "flex", flexDirection: "column", gap: "6px", textAlign: "center" }}>
          <strong style={{ fontSize: "22px" }}>
            مرحبا بك !
          </strong>
          <span style={{ fontSize: "15px", color: "#C9CEF5" }}>
            تعليم · ثقافة · لعب · اكتشاف — حساب للطفل في دقيقة.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-trimesters.webp" alt="شاشة اختر الثلاثي الدراسي" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            على نسق السنة الدراسيّة
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            الثلاثي الأوّل: بداية المغامرة · الثاني: مواصلة الرحلة · الثالث: نحو القمّة.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-subjects.webp" alt="شاشة اختر مغامرتك الدراسيّة: العربيّة، الفرنسيّة، الإنجليزيّة، الرياضيات، الإيقاظ العلمي، سؤال وجواب" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            اختر مغامرتك الدراسيّة
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            العربيّة، Français، English، الرياضيات، الإيقاظ العلمي، سؤال وجواب.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-games.webp" alt="شاشة ألعابي: لعبة الحساب، إخراج الجسم المحدّد، الذاكرة، الجمع والكورة" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            مغامرات التحدّي والإبداع
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            لعبة الحساب، الذاكرة، الجمع 2048… نقاط XP وعملات تحفّز على التقدّم.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-encyclopedia.webp" alt="شاشة موسوعتي بالواقع المعزّز: عالم الحيوانات، رحلة حول الكواكب، اكتشف جسم الإنسان" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            موسوعتي بالواقع المعزّز
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            عالم الحيوانات، رحلة حول الكواكب، اكتشف جسم الإنسان… كتب تنبض بالحياة.
          </span>
        </figcaption>
      </figure>
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(560px, 100%), 1fr))", gap: "20px" }}>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-variety.webp" alt="شاشة منوعاتي: فيديوهات، حكايات، قصص" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            منوعاتي: ماذا سأكتشف اليوم ؟
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            فيديوهات للمشاهدة والتعلّم، حكايات بودكاست، وقصص جديدة للقراءة.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-videos.webp" alt="شاشة الفيديوهات: قصص مصوّرة" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            قصص مصوّرة هادفة
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            سامي والغول ذو الرأسين، اللقلق المسنّ، الديك المخدوع… قيم تُروى بمتعة.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-avatar.webp" alt="شاشة صمّم شخصيتك مع رصيد النقاط والثقافة الماليّة" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            صمّم شخصيتك وتحدَّ أصدقاءك
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            «رصيدك − السعر = سيبقى لك»: نحو ثقافة ماليّة للتحكّم في المصروف اليومي.
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-sustainability-map.webp" alt="خريطة رحلة الاستدامة عبر القارّات" style={{ width: "100%", borderRadius: "18px", display: "block" }} />
        <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
          <strong style={{ fontSize: "19px" }}>
            رحلة الاستدامة حول العالم
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            قارّة بعد قارّة، يكتشف الطفل كوكبه ويتعلّم كيف يحميه.
          </span>
        </figcaption>
      </figure>
    </div>
  </section>
);

export default Demo;
